module.exports = __webpack_public_path__ + "img/icon_coupon.538d69b5.svg";